import { getUploadUrl, uploadFileToS3 } from "./uploadApi";

export const useFileUpload = () => {
    const uploadFile = async (file: File) => {
        // Step 1: Get presigned URL
        const uploadData = await getUploadUrl(file.name);
        console.log("Uploaded Date: ", uploadData);

        const { uploadUrl, key } = uploadData;

        // Step 2: Upload to S3
        const uploadResponse = await uploadFileToS3(
            uploadUrl,
            file
        );

        if (!uploadResponse.ok) {
            throw new Error("File upload failed");
        }

        return {
            key, // this will be your logoKey
        };
    };

    return { uploadFile };
};